export default __webpack_public_path__ + "static/media/StatusUp.f3bf4033.svg";